import { z } from "zod/v4";

// Branded ids: a CourtId can never be passed where a VenueId is expected.
export const venueIdSchema = z.uuid().brand<"VenueId">();
export const courtIdSchema = z.uuid().brand<"CourtId">();
export const reservationIdSchema = z.uuid().brand<"ReservationId">();
export const priceRuleIdSchema = z.uuid().brand<"PriceRuleId">();
export const closureIdSchema = z.uuid().brand<"ClosureId">();
export const userIdSchema = z.uuid().brand<"UserId">();

export type VenueId = z.infer<typeof venueIdSchema>;
export type CourtId = z.infer<typeof courtIdSchema>;
export type ReservationId = z.infer<typeof reservationIdSchema>;
export type PriceRuleId = z.infer<typeof priceRuleIdSchema>;
export type ClosureId = z.infer<typeof closureIdSchema>;
export type UserId = z.infer<typeof userIdSchema>;

/** A wall time on the wire: zero-padded 24h "HH:MM" (the API refuses seconds). */
export const wallTimeSchema = z
	.string()
	.regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Use HH:MM")
	.brand<"WallTime">();
export type WallTime = z.infer<typeof wallTimeSchema>;

/** A calendar date in the venue's zone, "YYYY-MM-DD". */
export const localDateSchema = z.iso.date().brand<"LocalDate">();
export type LocalDate = z.infer<typeof localDateSchema>;
